import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface AirwallexDescriptorCardProps {
    processor: ProcessorDetails
}

const getDescriptor = (options: Record<string, unknown> | null) => {
    return options?.descriptor as { descriptor?: string } | undefined
}

export const AirwallexDescriptorCard = ({ processor }: AirwallexDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const descriptor = getDescriptor(processor.options)

    if (!descriptor?.descriptor) {
        return null
    }

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('statementDescriptor')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-muted-foreground">{t('descriptor')}</p>
                        <p className="font-semibold">{descriptor.descriptor}</p>
                    </div>
                    <div className="rounded-lg bg-blue-50 p-3 border border-blue-200">
                        <p className="text-sm text-blue-700">
                            <strong>{t('note')}:</strong> {t('airwallexDescriptorNote')}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

